import mapboxgl from "mapbox-gl";
import React, { useCallback, useEffect, useRef, useState } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import styled from "styled-components";
import { cn } from "../../../util/classNameConstructor";
import usePolygonMask from "./hooks/usePolygonMask";
import { showMapbounds } from "./utils/showMapbounds";

const StaticMap = ({ mapbounds }) => {
  const mapContainer = useRef(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const [setPolygonMaskLayer, setPolygonMaskData] = usePolygonMask();

  useEffect(() => {
    if (!mapContainer.current) return;

    mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/tmorino/claqq4d85005014ohjoqds4wt",
      interactive: false,
    });
    if (map.current) setPolygonMaskLayer(map.current);

    return () => {
      if (map.current) {
        map.current.remove();
      }
    };
  }, []);

  const [ready, setReady] = useState(false);

  const addSource = useCallback(() => {
    try {
      map.current?.addSource("geojson", {
        type: "geojson",
        data: mapbounds,
      });
    } catch (error) {
      console.log(error);
    }
    if (map.current) {
      showMapbounds(map.current, mapbounds, true, setPolygonMaskData, 0);
    }
    setTimeout(() => {
      setReady(true);
    }, 100);
  }, [mapbounds, setPolygonMaskData]);

  useEffect(() => {
    if (map.current && mapbounds) {
      map.current.on("load", addSource);

      // If the map is already loaded, trigger the code directly
      if (map.current?._loaded) {
        addSource();
      }
    }
  }, [addSource, mapbounds]);

  return (
    <div
      ref={mapContainer}
      className={cn(
        "[&_.mapboxgl-ctrl]:!hidden [&_.mapboxgl-canvas]:!w-full [&_.mapboxgl-canvas]:!h-full [&_.mapboxgl-canvas]:object-cover",
        "bg-transparent duration-1000 ease-expressive-out aspect-[4/3]",
        ready ? "opacity-100" : "opacity-0",
      )}
    />
  );
};

export default StaticMap;
